var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.classCol, 'pr-1', _vm.$style.__button]},[_c('button',{class:['btn', 'btn-success', _vm.$style.__submit],attrs:{"type":'submit'}},[_vm._v(_vm._s(_vm.$t('button.send')))])])}
var staticRenderFns = []

export { render, staticRenderFns }